import { inject, Injectable } from '@angular/core';
import { ExperimentClient, initializeWithAmplitudeAnalytics } from '@amplitude/experiment-js-client';
import {
  EAmplitudeFeatureFlag,
  EAmplitudeFeatureFlagValues,
} from '@enums/amplitude-feature-flag/amplitude-feature-flag.enum';
import { StorageService } from '@providers/local-storage/storage.service';

@Injectable({
  providedIn: 'root',
})
export class AmplitudeFFService {
  private experimentClient: ExperimentClient;
  private storage: StorageService = inject(StorageService);

  public init(amplitude_api_key: string): void {
    const experiment: ExperimentClient = initializeWithAmplitudeAnalytics(amplitude_api_key);
    const userId: string | null = this.storage.get('user_id');
    experiment
      .fetch({
        ...(userId && { user_id: userId }),
      })
      .then((client) => (this.experimentClient = client));
  }

  public getVariant(key: EAmplitudeFeatureFlag): EAmplitudeFeatureFlagValues {
    if (!this.experimentClient) {
      return EAmplitudeFeatureFlagValues.OFF;
    }
    return this.experimentClient.variant(key, EAmplitudeFeatureFlagValues.OFF).value as EAmplitudeFeatureFlagValues;
  }
}
